<template>
  <div>
     <vs-dialog class="conciliacion" prevent-close @close="cerrarModal()" v-model="activeModal">
        <template #header>
          <h4 class="not-margin">
            Conciliar Pago
          </h4>
        </template>
        <h5>Alumno: {{row.nombre}}</h5>
        <h5>Matrícula: {{row.matricula}}</h5>
        <vs-table striped clas="table-responsive" v-dragscroll="{ target: '.vs-table', active: true }">
          <template #thead>
            <vs-tr>
              <vs-th>
                Institución
              </vs-th>
              <vs-th>
                Ciclo Escolar
              </vs-th>
              <vs-th>
                Programa
              </vs-th>
              <vs-th>
                No. de Autorización
              </vs-th>
              <vs-th>
                Fecha de pago
              </vs-th>
              <vs-th>
                Monto final
              </vs-th>
              <vs-th>
                No. de conceptos
              </vs-th>
              <vs-th>
                Monto por concepto
              </vs-th>
              <vs-th>
                Concepto
              </vs-th>
              <!-- <vs-th>
              </vs-th>
              <vs-th>
              </vs-th>
              <vs-th>
              </vs-th> -->
            </vs-tr>
          </template>
          <template #tbody>
            <vs-tr
              :key="i"
              v-for="(tr, i) in row.info"
              :data="tr"
              style="vertical-align: top;"
            >
              <vs-td>
                <md-content class="docientos">
                    <vs-select v-if="listInstituciones.length > 1" id="institucion" class="pt-0" filter :key="institucionId" v-model="institucion" :disabled="!listInstituciones.length > 1" autocomplete="off">
                          <vs-option v-for="option in listInstituciones" :key="option.id"  :label="option.text" :value="option.id">
                              {{option.text}}
                          </vs-option>
                    </vs-select>
                    <p class="mb-0" v-else v-for="option in listInstituciones" :key="option.id">{{option.text}}</p>
                </md-content>
              </vs-td>
              <vs-td>
                <md-content class="docientos">
                  <vs-select id="cicloEscolar" class="mr-0 pt-0" filter v-model="cicloEscolar"  :key="cicloId" :disabled="listCiclos.length < 1" >
                          <vs-option v-for="option in listCiclos" :key="option.id"  :label="option.text" :value="option.id">
                              {{option.text}}
                          </vs-option>
                  </vs-select>
                </md-content>
              </vs-td>
              <vs-td>
                <md-content class="docientos">
                  <vs-select id="programa" v-if="listPrograma.length > 1 " class="pt-0" :filter="Boolean(listPrograma.length > 1)" v-model="programa" :key="programaId" :disabled="!Boolean(listPrograma.length > 1)" >
                      <vs-option v-for="option in listPrograma" :key="option.id"  :label="option.text" :value="option.id">
                          {{option.text}}
                      </vs-option>
                  </vs-select>
                  <p class="mb-0" v-else v-for="option in listPrograma" :key="option.id">{{option.text}}</p>
                </md-content>
              </vs-td>
              <vs-td>
                {{ tr.autorizacion }}
              </vs-td>
              <vs-td>
                <md-content class="cien">
                {{ tr.fecha_pago }}
                </md-content>
              </vs-td>
              <vs-td>
                <md-content class="cien"
                @change="openNotification()">
                <span class="mr-1">{{ tr.monto_total | currency }}</span>
                <vs-tooltip v-if="(parseFloat(sumaTotal[i]) > parseFloat(tr.monto_total)) || (parseFloat(sumaTotal[i]) < parseFloat(tr.monto_total))">
                  <i class="fas fa-exclamation-circle" style="color: #E74C3C;"></i>
                  <template #tooltip>
                    La suma total de monto por concepto no es igual monto final
                  </template>
                </vs-tooltip>
                </md-content>
              </vs-td>
              <vs-td>
                <md-content class="cien">
                  <vs-input
                    class="pt-0"
                    type="number"
                    v-model="numConceptos[i]"
                     @input="fraccionarMonto(i)"
                     min="1"
                  ></vs-input>
                </md-content>
              </vs-td>
              <vs-td>
                <md-content class="cienCincuenta" v-for="(n,j) in parseInt(numConceptos[i]) || 0 " :key="j">
                  <vs-input
                    class="pt-0 pl-0"
                    type="number"
                    v-model="montoConcepto[i][j]"
                    @input="getSuma()"
                  ></vs-input>
                </md-content>
              </vs-td>
              <vs-td>
                <md-content class="docientos" v-for="(n,j) in parseInt(numConceptos[i]) || 0 " :key="j" style="display: block">
                  <vs-select class="pt-0 pl-0" filter v-model="cuenta[i][j]" placeholder="Concepto"  :key="conceptoId" :disabled="!listConceptos.length" @input="enableButton()">
                    <template #message-danger v-if="noConceptos">
                      {{ noConceptos == true ? 'Para este Ciclo escolar no hay reglas de cobro configuradas' : ''}}
                    </template>
                      <vs-option v-for="option in listConceptos" :key="option.id" :label="option.nombre" :value="option.id">
                        {{option.nombre}}
                      </vs-option>
                  </vs-select>
                  <p v-if="montoConcepto[i][j] !== '' && errores === true && cuenta[i][j] === ''" class="red mb-0"><strong> Campo Requerido</strong></p>
                </md-content>
              </vs-td>
             </vs-tr>
          </template>
        </vs-table>
        <template #footer>
          <div class="footer-dialog">
            <vs-button
              border
              :loading="loadingBoton"
              @click="getConciliar()"
              class="ml-auto"
              :disabled="buttonConciliar"
            >
              Conciliar pagos
            </vs-button>        
          </div>
        </template>
      </vs-dialog>
  </div>
</template>

<script>

import catalogos from '../../../../../api/requests/catalogos.js'
import cobranza from '../../../../../api/requests/cobranza-persona.js'
import reportes from '../../../../../api/requests/reportes.js'
export default {
    props:[  
      'value',
      'row',
    ],
    data () {
        return {
          activeModal: false,
          listInstituciones:[],
          institucion: '',
          institucionId: (new Date()).getTime(),
          cicloEscolar: '',
          listCiclos: [],
          cicloId: (new Date()).getTime(),
          programa: '',
          listPrograma: [],
          programaDefault: null,
          programaId:(new Date()).getTime(),
          conceptoId: (new Date()).getTime(),
          concepto: '',
          listConceptos: [],
          noConceptos : false,
          cuenta: [],
          numConceptos: [],
          descuentoOff: [],
          montoConcepto: [],
			    listDescuento: [],
          montoDescuento: null,
			    conceptoDescuento: [],
          conceptoDescuentoId: (new Date()).getTime(),
          montoConceptoDescuento: [],
          sumaTotal: [],
          sumaTotalConcepto: [],
          monto: [],
          errores: [],
          buttonConciliar: true,
          loadingBoton: false
        }
    },
    methods: {
      async getInsituto(){
            let params = {
              "persona": this.row.persona_id
          }
          const { data: response } = await catalogos.getInstitutosDefault(params) || {}
          const { opciones: info, default: val } = response || {}
          this.listInstituciones = info instanceof Object ?  Object.values(info) : []
          this.institucion = val
          this.institucionId = (new Date()).getTime()
      },
      async getCicloDefault() {
          let params = {
              "institucion_id": this.institucion,
                "persona_id": this.row.persona_id
          }
          const { data: response } = await catalogos.getCicloDefault(params) || {}
          const { opciones: info, default: val = null } = response || {}
          this.listCiclos = info instanceof Object ?  Object.values(info) : []
          this.cicloEscolar = val
          this.cicloId = (new Date()).getTime()
      },
      async getProgramas () {
          if (this.institucion && this.cicloEscolar){
          let params = {
              institucion_id: this.institucion,
              persona_id: this.row.persona_id,
              ciclo_escolar_id: this.cicloEscolar,
          }
          const { data: response } = await cobranza.getPrograma(params) || {}
          const { opciones: programas, default:val } = response || {}
              if (programas){
                  this.listPrograma = Object.values(programas)
                  this.programa = val
                  this.programaDefault = val
                  this.programaId = (new Date()).getTime()
              }
          }
      },
      async getConcepto() {
        if(this.cicloEscolar !== '' && this.programa !== ''){
        let params = {
          programa : this.programa,
          institucion: this.institucion,
          ciclo_escolar: this.cicloEscolar,
          tipo: "abierto",
          persona: this.row.idPersona,
        }
        const response = await cobranza.getConceptos(params) || {}
        this.concepto = ''
        this.listConceptos = response.data

        if (this.listConceptos && this.listConceptos.length && this.listConceptos.length >0 ){
          this.noConceptos = false
        }else {
          this.noConceptos = true
        }
        this.conceptoId = (new Date()).getTime()
        }
      },
      getUniqueMonto (){
        if(this.row != ''){
          let result = []
          let info = this.row.info
          info.forEach(i => {
              let arr = []
              arr.push('')
              result.push(arr)
          })
          this.montoConcepto = result
        }
      },
      getUniqueNoConceptos (){
        if(this.row != ''){
          let result = []
          let info = this.row.info
          info.forEach(i => {
            result.push("1")
          })
          this.numConceptos = result
        }
      },
      getErrores (){
        if(this.row != ''){
          let result = []
          let info = this.row.info
          info.forEach(i => {
              let arr = []
              arr.push(false)
              result.push(arr)
          })
          this.errores = result
        }
      },
      getUniqueConcepto (){
        if(this.row != ''){
          let result = []
          let info = this.row.info
          info.forEach(i => {
              let arr = []
              arr.push('')
              result.push(arr)
          })
          this.cuenta = result
        }
      },
      getUniqueDescuento (){
        if(this.row != ''){
          let result = []
          let info = this.row.info
          info.forEach(i => {
              let arr = []
              arr.push(false)
              result.push(arr)
          })
          this.descuentoOff = result
        }
      },
      getUniqueConceptoDescuento (){
        if(this.row != ''){
          let result = []
          let info = this.row.info
          info.forEach(i => {
              let arr = []
              arr.push('')
              result.push(arr)
          })
          this.conceptoDescuento = result
        }
      },
      getUniqueConceptoDescuentoMonto  (){
        if(this.row != ''){
          let result = []
          let info = this.row.info
          info.forEach(i => {
              let arr = []
              arr.push('')
              result.push(arr)
          })
          this.montoConceptoDescuento = result
        }
      },
      async initCatalogs() {
        if (!this.listDescuento.length){
          try {
            const { data: descuentos } = await catalogos.getDescuentos()
            if (Array.isArray(descuentos)){
              this.listDescuento = descuentos
              this.conceptoDescuentoId = (new Date()).getTime()
            }
          } catch (error) {
            console.log(error)
          }
        }
        await this.getConcepto()
      },   
      fraccionarMonto (index) {
          const dif = this.numConceptos[index] - this.montoConcepto[index].length
          if (dif < 0){
            for (let j = 0; j < Math.abs(dif); j++){
              this.montoConcepto[index].pop()
              this.descuentoOff[index].pop()
              this.conceptoDescuento[index].pop()
              this.cuenta[index].pop()
              this.montoConceptoDescuento[index].pop()
            }
          }
          else{
            for (let j = 0; j < dif; j++){
              this.montoConcepto[index].push('')
              this.conceptoDescuento[index].push('')
              this.cuenta[index].push('')
              this.descuentoOff[index].push(false)
              this.montoConceptoDescuento.push('')
            }
          }
          this.getSuma()
      },
      getGet(valor){
        console.log(valor)
      },
      getSuma(){
        const vue = this
        const cuenta = vue.cuenta
        cuenta.forEach(function(cuenta,index){
          let suma = 0.00
          let monto = vue.montoConcepto[index]
          monto.forEach(i => {
            if(i !== ''){
              suma = parseFloat(suma) + parseFloat(i);
            }
          })
          // let montoConceptoDescuento = vue.montoConceptoDescuento[index]
          // let sumaDescuento = 0.00
          // montoConceptoDescuento.forEach(function(desc,i){
          //   if(desc !== '' && vue.descuentoOff[index][i]){
          //     sumaDescuento = parseFloat(sumaDescuento) + parseFloat(desc);
          //   }
          // })
          
          // vue.sumaTotalConcepto[index] = sumaDescuento
          // if(vue.sumaTotalConcepto[index] > 0){
          //   vue.sumaTotal[index] = parseFloat(suma) - parseFloat(vue.sumaTotalConcepto[index])
          // }else{
            vue.sumaTotal[index] = parseFloat(suma)
          // }
        })
        vue.enableButton()
      },
      async getConciliar(){
      	try {
          this.loadingBoton = true
          const vue = this
          const info = this.row.info
          let pagos = []
          info.forEach(function(fila,i) {
            vue.montoConcepto[i].forEach(function(monto,j) {
              if(vue.montoConcepto[i] !== '' && vue.cuenta[i][j] !== ''){
                let obj = {
                  'monto': monto,
                  'programa': vue.programa,
                  'fecha': vue.row.info[i].fecha_pago,
                  'metodo_pago': vue.row.info[i].tipo_pago_id,
                  'codigo_detalle': vue.cuenta[i][j],
                  'persona': vue.row.persona_id,
                  'ciclo_escolar': vue.cicloEscolar,
                  'institucion': vue.institucion,
                  'num_autorizacion': vue.row.info[i].autorizacion,
                  'facturar': true
                  // 'descuentos' : {
                  //   'monto' : vue.montoConceptoDescuento[i][j],
                  //   'codigo_detalle' :vue.conceptoDescuento[i][j]
                  // }
                }
                pagos.push(obj)
              }
            })
          })
          let datos = pagos
          let tipo = "abierto"
          let alumnos = datos
          const response = await reportes.getConciliar(alumnos,tipo)
      		this.$emit('refreshTable',true)
          this.activeModal = false
          this.loadingBoton = false

        } catch (error) {
          this.loadingBoton = false
          this.activeModal = false
          this.errores = true
      		this.$emit('refreshTable',true)
          this.$vs.notification({
              progress: 'auto',
              color: 'danger',
              position: null,
              title: 'Algo salio mal',
              text: error.response.data.errores.descripcion
          })
        }
      },
      getIfDescuento(){
        const vue = this
        this.descuentoOff.forEach(function(data,i){
          data.forEach(function(desc,j){
            if(desc === false){
              vue.conceptoDescuento[i][j] = ''
              vue.montoConceptoDescuento[i][j] = ''
            }
          })
          // this.getSuma()
        })
      },
      enableButton(){
        let errores = 0
        const monto = this.row.info
        const suma = this.sumaTotal
        const cuenta = this.cuenta
        const descuento = this.descuentoOff
        const conceptoDescuento = this.conceptoDescuento
        const montoDescuento = this.montoConceptoDescuento

        monto.forEach(function(data,i){
          if (parseFloat(data.monto_total) !== parseFloat(suma[i])){
            errores++
          }
        })

        cuenta.forEach(data=>{
          data.forEach(i=>{
            if (i === '' || i === null){
              errores++
            }
          })
        })
        descuento.forEach(function(data,i){
          data.forEach(function(val,j){
            if(val){
              if(conceptoDescuento[i][j] === '' || conceptoDescuento[i][j] === null){
                errores++
              }
              if (montoDescuento[i][j] === '' || montoDescuento[i][j] === null){
                errores++
              }
            }
          })
        })

        if (errores === 0){
          this.buttonConciliar = false
        }
        else{
          this.buttonConciliar = true
        }
      },
      cerrarModal(){
      		this.$emit('refresModal',true)
      }
    },
    watch: {
        value (val) {
            this.activeModal = val
            this.getUniqueConcepto()
            this.getUniqueConceptoDescuento()
            this.getUniqueDescuento()
            this.getUniqueConceptoDescuentoMonto()
            this.getUniqueNoConceptos()
            this.getUniqueMonto()
        },     
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        row(){
            this.getInsituto()
        },
        institucion(){
          this.getCicloDefault()
        },
        cicloEscolar(){
            this.getProgramas()
        },
        programa(){
          this.getConcepto()
        },
        descuentoOff(){
          this.initCatalogs()
          this.getSuma()
          this.getIfDescuento()
        },
        montoConceptoDescuento(){
          this.getSuma()
        },
        conceptoDescuento(){
          this.getSuma()
        },
        // montoConcepto(){
        //   this.getSuma()
        // },
        // cuenta(){
        //   this.getSuma()
        // },
    }
}
</script>

<style lang="scss"  scoped >
  .color-blue {
    background-color: #005aa3;
  }
  .cien{
      width: 100px;
      background: none;
      display: inline-flex;
      justify-content: center;
      align-items: center;
  }
  .docientos {
      width: 200px;
      background: none;
      display: inline-flex;
      justify-content: center;
      align-items: center;
  }
  .cienCincuenta {
      width: 150px;
      background: none;
      display: inline-flex;
      justify-content: center;
      align-items: center;
  }
  .trecientos{
      width: 300px;
      background: none;
      display: inline-flex;
      justify-content: center;
      align-items: center;

  }
  
  .red {
      color: red;
      padding-left: 15px;
      font-size: 11px;
  }
</style>
<style>
  .conciliacion .vs-dialog{
    width: auto !important;
    max-width: 1200px !important;
  }
  .conceptos .vs-switch{
    height: 15px !important;
    min-width: 30px !important;
  }

  .conceptos .vs-switch .vs-switch__circle{
    width: 13px !important;
    height: 13px !important;
  }

  .conceptos .vs-switch .vs-switch__input:checked ~ .vs-switch__circle{
    left: calc(100% - 15px) !important;
  }
</style>